export { default, getServerSideProps } from './TrackDetail';
